// @flow
import * as React from 'react';
import { AgentView, Portal, useDeleteClientNoteMutation } from '../../../../../shared';
import { Client } from '../../../../../shared/api/use-client-subscription';
import { ButtonBase, Divider, IconButton, Stack, Typography } from '@mui/material';
import { getUserName } from '@coverright/utils';
import moment from 'moment';
import { X } from '@phosphor-icons/react';
import { useNoteForm, withNoteForm } from '../../../../../features/note-form';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../../../app/theme';
import { enqueueSnackbar } from 'notistack';

type Props = {
  note: Client['notes'][0]
};
const Item = ({note}: Props) => {
  const {open} = useNoteForm()
  const confirm = useConfirm(theme);
  const [deleteNote] = useDeleteClientNoteMutation({onCompleted: () => enqueueSnackbar('Note deleted!', {variant: 'info'})});

  const handleDeleteClick = () => {
    confirm({
      content: 'Are you sure you want to delete this note? You will not able to restore it later!',
      okButtonTitle: 'Yes',
      cancelButtonTitle: 'No',
      title: 'Warning!',
    })
      .then(val => {
        if (val) {
          deleteNote({
            variables: {noteId: note.id}
          })
        }
      })
  }

  const isManager = note.isManagerNote === true;

  return <Portal>
    <Stack py={1} gap={2} direction={'row'} px={2} alignItems={'center'}
           bgcolor={isManager ? '#FEE2E2' : '#e2f3f1'}
           sx={{borderTopLeftRadius: '4px', borderTopRightRadius: '4px'}}>
      <AgentView agent={note.createdByAgent ? {
        fullName: getUserName(note.createdByAgent),
        email: note.createdByAgent.email,
        picUrl: note.createdByAgent.picUrl
      } : { fullName: 'No agent' }} />
      {isManager && <Typography variant={'caption'} sx={{fontWeight: 700, color: '#DC2626'}}>Manager</Typography>}
      <Typography flex={1} color={'text.secondary'} variant={'caption'} align={'right'}>
        {moment(note.updatedAt).format('L H:mm')}
      </Typography>
      <IconButton size={'small'} onClick={handleDeleteClick}>
        <X size={16} color={'#DE3124'} />
      </IconButton>
    </Stack>
    <Divider />
    <ButtonBase sx={{'&:hover': {bgcolor: isManager ? '#FEF2F2' : 'secondary.50'}, px: 2, py: 1, justifyContent: 'initial'}}
                onClick={() => open(note.clientId, note, isManager)}>
      <Typography color={'text.secondary'} whiteSpace={'pre-line'} variant={'body2'} align={'left'}>
        {note.note}
      </Typography>
    </ButtonBase>

  </Portal>
}

  export const NoteItem = withNoteForm(Item)
